import { IconShapeSettings } from '@lessonup/pins-shared';
import React from 'react';
import { hotspotIconMapper, transformHotspotIconRecordEntryToType } from '../../HotspotPinComponent/hotspot.utils';

export interface IconShapeProps {
  iconName: IconShapeSettings['iconName'];
}

export const IconShape: React.FC<IconShapeProps> = ({ iconName = 'ROCKET' }) => {
  const { icon: IconComponent } = transformHotspotIconRecordEntryToType(hotspotIconMapper[iconName]);

  return React.cloneElement(IconComponent, { width: '100%', height: '100%', stroke: 'none' });
};
